// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Notifications from 'vue-notification'
import Axios from 'axios'
import logger from './utils/logger'

Vue.config.productionTip = false

Vue.use(Notifications)

// Axios.defaults.withCredentials = true
// Axios.defaults.headers.common.Accept = 'application/json'
// Axios.defaults.headers.common.Accept = 'application/x-www-form-urlencoded; charset=UTF-8'
Axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  // Do something with response error
  const response = error.response
  const status = response.status
  logger.d('main', 'axios', status, response.data)
  if (response.data.err_code === 500 && response.data.err_message === 'Access denied') {
    logger.d('main', 'axios', 'expired')
  } else if (response.data.err_code === 401 || response.data.err_code === 403) {
    logger.d('main', 'axios', 'expired')
  }
  return Promise.reject(error.response)
})
window.axios = Axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js